import { Spinner } from "react-bootstrap";

export default function SaveButton({ handleSave, lockNextBtn }) {
	return (
		<button className="btn bg-agro-outline bg-agro-outline-save-btn" onClick={handleSave} disabled={lockNextBtn}>
			{lockNextBtn && <Spinner style={{ width: "4rem", height: "4rem" }} className="spinner-loading" animation="border" size="" />}
			Guardar y continuar despues
		</button>
	);
}
